<template>
  <div v-if="visible" class="resumen-ia mb-3">
    <div v-if="existe" class="resumen-ia__card">
      <div class="resumen-ia__head" @click="abierto = !abierto">
        <v-icon small color="deep-purple">mdi-text-box-outline</v-icon>
        <span class="resumen-ia__titulo">Resumen de IA</span>
        <v-spacer></v-spacer>
        <v-icon small>{{ abierto ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </div>
      <ul v-show="abierto" class="resumen-ia__lista">
        <li v-for="(p, i) in puntos" :key="i">{{ p }}</li>
      </ul>
    </div>
    <div v-else>
      <v-btn small text color="deep-purple" :loading="cargando" @click="generar">
        <v-icon small left>mdi-text-box-outline</v-icon>Generar Resumen de IA
      </v-btn>
      <span v-if="error" class="caption error--text ml-2">{{ error }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      idticket: { type: [Number, String], default: null },
      auto: { type: Boolean, default: true },
    },

    data: () => ({
      aplica: false,
      califica: false,
      existe: false,
      puntos: [],
      cargando: false,
      error: '',
      abierto: true,
    }),

    computed: {
      visible () {
        return this.aplica && (this.existe || this.califica)
      },

      // Por ahora solo para el Jefe de TI (puesto 11), a peticion suya.
      habilitado () {
        return Number((this.$store.getters['login/getdatosUsuarioERPERP'] || {}).idpuesto) === 11
      },
    },

    watch: {
      idticket: { immediate: true, handler: 'consultar' },
    },

    methods: {
      aplicar (d) {
        this.aplica = d.aplica_rol !== false
        this.califica = !!d.califica
        this.existe = !!d.existe && Array.isArray(d.puntos) && d.puntos.length > 0
        this.puntos = this.existe ? d.puntos : []
      },

      consultar () {
        this.aplica = this.califica = this.existe = false
        this.puntos = []
        this.error = ''
        if (!this.idticket || !this.habilitado) return
        const id = this.idticket
        this.$http.get('tickets.resumen.ia/' + id).then((r) => {
          if (id !== this.idticket) return
          this.aplicar(r.data || {})
          if (this.auto && this.aplica && this.califica && !this.existe) this.generar()
        }).catch(() => {})
      },

      generar () {
        this.cargando = true
        this.error = ''
        const id = this.idticket
        this.$http.post('tickets.resumen.ia', { idticket: id }).then((r) => {
          if (id === this.idticket) this.aplicar({ ...r.data, existe: true })
        }).catch((e) => {
          const d = (e.response && e.response.data) || {}
          this.error = d.message || 'No se pudo generar el resumen'
        }).finally(() => { this.cargando = false })
      },
    },
  }
</script>

<style scoped>
  .resumen-ia__card {
    border: 1px solid #dadce0;
    border-radius: 12px;
    background: #f8f9fd;
    padding: 10px 14px;
  }
  .resumen-ia__head { display: flex; align-items: center; cursor: pointer; }
  .resumen-ia__titulo { margin-left: 6px; font-size: 14px; font-weight: 500; color: #4527a0; }
  .resumen-ia__lista { margin: 8px 0 2px; padding-left: 20px; font-size: 14px; line-height: 1.45; }
  .resumen-ia__lista li { margin-bottom: 4px; }
</style>
